import * as React from "react";
import { NumberInput, ReferenceInput, SelectInput, required } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { SourceCustomer } from "../../Customer";
import { SourceMelCategory } from "../../MelCategory/Constant/Source";

const MelCategoryCustomerCreateForm = () => {
  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <ReferenceInput
                    label="CUSTOMER NAME"
                    source="customerId"
                    reference={SourceCustomer}
                    translateChoice={false}
                    validate={required()}
                  >
                    <SelectInput optionText="customerName" optionValue="id" fullWidth />
                  </ReferenceInput>
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <ReferenceInput
                    label="CATEGORY NAME"
                    source="categoryId"
                    reference={SourceMelCategory}
                    translateChoice={false}
                    validate={required()}
                  >
                    <SelectInput optionText="categoryName" optionValue="id" fullWidth />
                  </ReferenceInput>
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="rddTimeInside" label="RDD TIME INSIDE" validate={required()} fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="rddTimeOutside" label="RDD TIME OUTSIDE" validate={required()} fullWidth />
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="successRate" label="SUCCESS RATE" max={99} validate={required()} fullWidth />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default MelCategoryCustomerCreateForm;
